import { createAction } from 'typesafe-actions';
import { YoutubeVideo } from '@lib/domain/youtube';
import { OrderWithEmail, DefaultYoutubeProps } from '@lib/domain/order';
import { createActionTypePrefixFormat } from '../common';

const typePrefixFormat = createActionTypePrefixFormat('Youtube');

/* ------------- action creators ------------- */
export const setVideoSelected = createAction(
    typePrefixFormat('SET_YOUTUBE_VIDEO_SELECTED'),
    (videos: string[]) => ({
        videos,
    }), // payload creator
)();
export const setYoutubeVideo = createAction(
    typePrefixFormat('SET_YOUTUBE_VIDEO'),
    (video: YoutubeVideo[]) => ({
        video,
    }), // payload creator
)();

export const setYoutubeListVideos = createAction(
    typePrefixFormat('SET_YOUTUBE_LIST_VIDEOS'),
    (videos: YoutubeVideo[]) => ({
        videos,
    }), // payload creator
)();

export const setYoutubeChannel = createAction(
    typePrefixFormat('SET_YOUTUBE_CHANNEL'),
    (channel: YoutubeVideo) => ({
        channel,
    }), // payload creator
)();

export const setYoutubeListChannels = createAction(
    typePrefixFormat('SET_YOUTUBE_LIST_CHANNELS'),
    (channel: YoutubeVideo[]) => ({
        channel,
    }), // payload creator
)();

export const setNextPageTokenVideo = createAction(
    typePrefixFormat('SET_YOUTUBE_TOKEN_VIDEO'),
    (token: string | undefined) => ({
        token,
    }), // payload creator
)();

export const setYoutubeOrder = createAction(
    typePrefixFormat('SET_YOUTUBE_ORDER'),
    (order: OrderWithEmail, defaultValuePayload: DefaultYoutubeProps) => ({
        order,
        defaultValue: defaultValuePayload,
    }),
)();

export const setYoutubeDefault = createAction(
    typePrefixFormat('SET_YOUTUBE_DEFAULT'),
    (payload: DefaultYoutubeProps) => payload,
)();

export type YoutubeActions = ReturnType<
    | typeof setYoutubeVideo
    | typeof setYoutubeListVideos
    | typeof setYoutubeOrder
    | typeof setYoutubeDefault
    | typeof setYoutubeChannel
    | typeof setYoutubeListChannels
    | typeof setNextPageTokenVideo
>;
